/**
 * Enum for side navigation element IDs in the worklist
 */
export enum SideNavElementId {
  MedicalPaOrders = "medical-pa-orders",
  MyPaOrders = "my-pa-orders",
  ReviewPending = "review-pending",
  AuthRequired = "auth-required",
  Pending = "pending",
  Query = "query",
  Hold = "hold",
  FinalWorklist = "final-worklist",
  FinalWorklistUpload = "final-worklist-upload",
  ReferralRequired = "referral-required",
}

/**
 * Enum for Algolia facet attribute names
 */
export enum AlgoliaFacetAttribute {
  MasterAuthStatus = "master_auth_status",
  BoStatus = "bo_status",
  RegimenName = "regimen_name",
  PrimaryPayerName = "primary_payer_name",
  PractitionerName = "practitioner_name",
  Location = "location",
  AssignedTo = "assigned_to",
  EvBvPrimary = "ev_bv_primary",
  AuthStatus = "auth_status",
  DocumentUploadStatus = "document_upload_status",
  EvWriteBackStatus = "ev_write_back_status",
  MedicalOrderReviewStatus = "medical_order_review_status",
}

/**
 * Enum for master_auth_status facet values
 */
export enum MasterAuthStatusValue {
  New = "new",
  AuthRequired = "auth_required",
  Pending = "pending",
  Query = "query",
  Hold = "hold",
  AuthOnFile = "auth_on_file",
  NoAuthRequired = "no_auth_required",
  OralDrug = "oral_drug",
  Urology = "urology",
  Pcp = "pcp",
  NotToWorkOralDrug = "not_to_work_oral_drug",
  NotToWorkFedora = "not_to_work_fedora",
  PatientOwnedDrug = "patient_owned_drug",
  NotApplicable = "not_applicable",
  AuthByRisa = "auth_by_risa",
  NotAvailable = "not_available",
}

/**
 * Enum for bo_status facet values
 */
export enum BoStatusValue {
  Required = "Required",
  Authorized = "Authorized",
  NotApplicable = "Not Applicable",
  Financial = "Financial",
  AuthMate = "AuthMate",
  PodVerify = "POD - Verify",
  AuthMatePending = "AuthMate-Pending",
  InsuranceIssue = "Insurance Issue",
  AuthIssueOnsite = "Auth Issue (Onsite)",
  AuthorizedFinancial = "Authorized/Financial",
  InsuranceResolved = "Insurance Resolved",
}
